import { useTheme } from "@tamagui/core";
export const useSporeColors = useTheme;
